import { faTrophy } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { imgIconGoldenTicketSvg, imgLogoStrictlyFootball_2xPng } from '~/src/images';
import styles from '~/src/lib/styles.json';
import PowerRankingsTable from '../Standings/PowerRankingsTable';
import './PowerRankings.scss';

const PowerRankings = () => {
	return (
		<>
			<div className="Phase">
				<img src={imgLogoStrictlyFootball_2xPng} />
				<div className="Primary">Power Rankings</div>
				{/* <div className="Secondary">
					<div className="Location">
						<div className="City">Miami, FL</div>
						<div className="Date">Fri, Jun 27 - Sat, Jun 28</div>
					</div>
					<div className="StandingsLink">
						<a href={`/standings/playoffs/tournament`}>
							<img src={imgIconStandingsBracketSvg} />
							Bracket
						</a>
					</div>
				</div> */}
			</div>
			<PowerRankingsTable />
			<div className="Footnotes">
				<div className="Footnote">
					<div className="Icon">📆</div>
					<div className="Text">Rankings updated 4/8/25</div>
				</div>
				<div className="Footnote">
					<div className="Icon Trophy">
						<FontAwesomeIcon icon={faTrophy} style={{ color: styles.COLOR.BRAND_PRIMARY }} size={'2x'} />
					</div>
					<div className="Text">Denotes Division Champ</div>
				</div>
				{/* <div className="Footnote">
							<div className="Icon">
								<div className="GreenDash"></div>
							</div>
							<div className="Text">Denotes playoff qualification</div>
						</div> */}
				<div className="Footnote">
					<div className="Icon">
						<img src={imgIconGoldenTicketSvg} alt="Golden Ticket" />
					</div>
					<div className="Text">Denotes Golden Ticket Winner</div>
				</div>
			</div>
		</>
	);
};

export default PowerRankings;
